<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="pointer" @contextmenu.prevent="onShowContextMenu($event)">
    <v-list-item class="interaction-item blink">
      <v-list-item-avatar>
        <v-progress-circular
          v-if="isLoading && !interaction.isPreview"
          class="timer-background"
          :rotate="-90"
          :size="32"
          :width="3"
          :value="progressCircularValue"
          :color="'#fff'"
        >
          {{ timer.remaining }}
        </v-progress-circular>
        <EcsInteractionAvatar v-else :interaction="interaction" :size="40" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="interaction-title">
          <div class="originator">{{ originator }}</div>
        </v-list-item-title>
        <v-list-item-subtitle class="interaction-sub-title">
          {{ businessProcess }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import moment from 'moment';
import EcsInteractionAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsInteractionAvatar';
import EcsInteractionTimerMixin from '@/mixins/ecs-interaction-mixin/EcsInteractionTimerMixin';

export default {
  name: 'EcsSideBarPendingInteractionItem',

  components: { EcsInteractionAvatar },

  mixins: [EcsInteractionTimerMixin],

  props: {
    interaction: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      timer: {}
    };
  },

  computed: {
    originator() {
      return !this.interaction.isInternal && this.interaction.isPendingConsult
        ? this.interaction.consultRequestorDisplayName
        : this.interaction.formattedCustomerFullName;
    },
    businessProcess() {
      let businessProcess = '';
      if (this.interaction.isInternal) {
        if (this.interaction.isTelephony) {
          businessProcess = this.$t('internal_call');
        } else if (this.interaction.isChat) {
          businessProcess = this.$t('internal_chat');
        }
      } else if (this.interaction.isPendingConsult) {
        businessProcess = this.$t('consult');
      } else {
        businessProcess = this.interaction.routing.businessProcessName;
      }
      return businessProcess;
    },

    isLoading() {
      return !this.interaction.isPendingConsult && !this.interaction.isInternal && this.timer.remaining > 0;
    },

    progressCircularValue() {
      return (100 / this.interaction.timing.noAnswerTimeout) * this.timer.remaining;
    }
  },

  mounted() {
    this.$ringtoneManager.startInteractionRingtone(this.interaction);
    this.startInteractionTimer();
  },

  destroyed() {
    this.$ringtoneManager.stopInteractionRingtone();
    this.stopInteractionTimer(this.timer);
  },

  methods: {
    onShowContextMenu(event) {
      const clientRect = event.target.getBoundingClientRect();
      this.$root.$emit('open-interaction-context-menu', {
        interaction: this.interaction,
        x: clientRect.x,
        y: clientRect.y
      });
    },

    timerInterval: self =>
      setInterval(() => {
        const thisTimer = self.timer;
        if (thisTimer.remaining > 0) {
          const now = moment.utc();
          thisTimer.remaining = thisTimer.expirationTimestamp.diff(now, 'seconds');
        } else {
          clearInterval(thisTimer.interval);
        }
      }, 1000),

    startInteractionTimer() {
      if (this.interaction) {
        this.$ringtoneManager.startInteractionRingtone(this.interaction);
        this.timer = this.createTimer(this.interaction);
        this.timer.interval = this.timerInterval(this);
      } else {
        this.$ringtoneManager.stopInteractionRingtone();
      }
    }
  }
};
</script>

<style>
.timer-background {
  background-color: var(--v-secondary-base);
  border-radius: 50%;
}
.originator {
  max-width: 220px;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
</style>
